import Api from '../../index';
import { requestType, endPoints } from '../../../constants/variables';

export const getAdminDashboardStats = (params) => {
  return Api(endPoints.dashboardData, null, requestType.POST);
};
